import OnestockOnboardingLayoutContainer from "./OnestockOnboardingLayoutContainer";
import OnestockOnboardingLayoutStore from "./OnestockOnboardingLayoutStore";

export default OnestockOnboardingLayoutStore(OnestockOnboardingLayoutContainer);